import { jsx as _jsx } from "react/jsx-runtime";
import { useI18n } from '@design-system/i18n';
import { SimpleCard } from '@design-system/simple-card';
export const BlockEmptyContent = ({ buttonProps, data = {}, description, faIconProps = {
    iconName: 'megaphone',
}, shouldDisplay = () => false, title, }) => {
    const { s__ } = useI18n();
    if (!shouldDisplay({ data })) {
        return null;
    }
    return (_jsx(SimpleCard, { buttonProps: buttonProps, cardProps: {
            mx: 'auto',
            width: '100%',
            maxWidth: '655px',
        }, description: description || s__("EmptyContent|It shouldn't be long, come back later!"), faIconProps: faIconProps, title: title || s__('EmptyContent|Nothing to see for the moment') }));
};
//# sourceMappingURL=index.js.map